import type { RankProgress } from "./ws-client.js";

export interface PlayerProgressionState {
  guildId: string | null;
  discordId: string | null;
  rankProgress: RankProgress | null;
}

type PlayerProgressionSubscriber = (state: Readonly<PlayerProgressionState>) => void;

/** Current viewer's guild-scoped points and rank. Shared garden points live in points-state. */
class PlayerProgressionStore {
  private state: PlayerProgressionState = {
    guildId: null,
    discordId: null,
    rankProgress: null,
  };
  private subscribers = new Set<PlayerProgressionSubscriber>();

  getState(): Readonly<PlayerProgressionState> {
    return { ...this.state };
  }

  setContext(guildId: string | null, discordId: string | null): void {
    if (this.state.guildId === guildId && this.state.discordId === discordId) return;
    this.state = { guildId, discordId, rankProgress: null };
    this.notify();
  }

  setRankProgress(rankProgress: RankProgress): void {
    this.state = { ...this.state, rankProgress: { ...rankProgress } };
    this.notify();
  }

  clear(): void {
    this.setContext(null, null);
  }

  subscribe(subscriber: PlayerProgressionSubscriber): () => void {
    this.subscribers.add(subscriber);
    subscriber(this.getState());
    return () => this.subscribers.delete(subscriber);
  }

  private notify(): void {
    const state = this.getState();
    for (const subscriber of this.subscribers) subscriber(state);
  }
}

export const playerProgressionStore = new PlayerProgressionStore();
export { PlayerProgressionStore };
